import type { paths } from '@luxuryescapes/contract-svc-lux-loyalty'
import * as libRegions from '@luxuryescapes/lib-regions'

type LoyaltyRegionCode = paths['/api/lux-loyalty/account']['post']['parameters']['body']['payload']['region']

/**
 * Checks if the provided region is a valid loyalty region.
 * Also it is used a type predicate.
 * @param {string | undefined} region - The region code to validate.
 * @returns {boolean} - Returns true if the region is valid, false otherwise.
 */
export default function isValidLoyaltyRegion(region: string | undefined): region is LoyaltyRegionCode {
  return region !== undefined && libRegions.getRegionCodes().includes(region.toUpperCase())
}
